import useBizNode from '../../useBizNode.mjs'
import readProject from '../readProject.mjs'

export default (type, ownerId, componentType, id) => {
    const BizNode = useBizNode()

    return async () => {
        const initData = await BizNode[componentType].readMap({id, ownerId})
        const {prjId, sVer} = initData.data
        const project = await readProject(prjId, sVer)
        Object.assign(initData.data, project)
        return initData
    }
}
